export const COPILOT_PLANS = {
  free: {
    enabled: true,
    monthlyLimits: {
      analysis: 1,
      actions: 1,
    }
  },

  trial: {
    enabled: true,
    monthlyLimits: {
      analysis: 1,
      actions: 1,
    }
  },

  standardMonthly: {
    enabled: false,
    monthlyLimits: {
      analysis: 1,
      actions: 1,
    }
  },

  standardYearly: {
    enabled: false,
    monthlyLimits: {
      analysis: 1,
      actions: 1,
    }
  },

  premiumMonthly: {
    enabled: true,
    monthlyLimits: {
      analysis: 5,
      actions: 10,
    }
  },

  premiumYearly: {
    enabled: true,
    monthlyLimits: {
      analysis: 5,
      actions: 10,
    }
  },

  unlimitedMonthly: {
    enabled: true,
    monthlyLimits: {
      analysis: 10,
      actions: 30,
    }
  },

  unlimitedYearly: {
    enabled: true,
    monthlyLimits: {
      analysis: 10,
      actions: 30,
    }
  }
}


export const COPILOT_FEATURES = [
  "revenue_analysis",
  "expense_analysis",
  "customer_analysis",
  "trend_detection",
  "recommendations"
]